import type { Tables } from "@/integrations/supabase/types";

type Profile = Tables<"profiles">;

export function calcDistanceKm(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
  return Math.round(R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
}

export function scoreCandidate(
  candidate: Profile,
  myProfile: Profile,
  myLat: number | null,
  myLng: number | null
): number {
  let score = 0;
  const myInterests = new Set(myProfile.dating_interests ?? []);
  const theirInterests = candidate.dating_interests ?? [];
  if (myInterests.size === 0 || theirInterests.length === 0) {
    score += 35;
  } else {
    const shared = theirInterests.filter(i => myInterests.has(i)).length;
    const maxCount = Math.max(myInterests.size, theirInterests.length, 1);
    score += (shared / maxCount) * 35;
  }

  const cLat = candidate.live_latitude ?? candidate.latitude;
  const cLng = candidate.live_longitude ?? candidate.longitude;
  if (myLat != null && myLng != null && cLat != null && cLng != null) {
    const dist = calcDistanceKm(myLat, myLng, cLat, cLng);
    score += Math.max(0, 25 - dist / 20);
  }

  if (!myProfile.looking_for || !candidate.looking_for ||
      candidate.looking_for === myProfile.looking_for) {
    score += 15;
  }

  if (!candidate.age || !myProfile.age_range_min || !myProfile.age_range_max) {
    score += 10;
  } else if (candidate.age >= myProfile.age_range_min && candidate.age <= myProfile.age_range_max) {
    score += 10;
  }

  if (candidate.dating_bio && candidate.dating_bio.length > 10) score += 5;

  const photoCount = candidate.dating_photos?.length ?? 0;
  score += Math.min(photoCount, 5);

  if (!myProfile.ethnicity_preference?.length || !candidate.ethnicity ||
      myProfile.ethnicity_preference.map(e => e.toLowerCase()).includes(candidate.ethnicity.toLowerCase())) {
    score += 5;
  }

  return Math.round(score);
}

export function getScoreColor(score: number): string {
  if (score >= 80) return "text-success";
  if (score >= 60) return "text-primary";
  if (score >= 40) return "text-accent";
  return "text-muted-foreground";
}
